import { Component, ChangeDetectionStrategy } from '@angular/core';

/** Compatibility wrapper: both layouts render the same navigation tree. */
@Component({ selector: 'app-eco-sidebar', templateUrl: './eco-sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush, standalone: false })
export class EcoSidebarComponent {}
